module.exports = __webpack_public_path__ + "static/media/home_bridge.700b5f0c.png";